import { useNavigate } from "react-router-dom"
import Input, { clearForm, required, submitForm, useInput } from "../../components/input"
import { api } from "../../env"
import { getStorage, setStorage, STORAGE } from "../../utils/storage"
import { routeAfterLogin, routeEnrollment } from "../../utils/enrollment"
import LoadingButton from "../../components/LoadingButton"
import { useEffect, useState } from "react"

export default function Auth() {

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [isVerified, setIsVerified] = useState(true)
    const [isVerificationResent, setIsVerificationResent] = useState(false)
    const [isForgetPassword, setIsForgetPassword] = useState(false)
    
    const loginForm = {
        email: useInput("Email", "email", "email", [required]),
        password: useInput("Password", "lock", "password", [required])
    }
    const [rememberMe, setRememberMe] = useState(false)

    useEffect(() => {
        const code = getStorage(STORAGE.PARTICIPANT_INVITE_CODE)
        const hasAccount = getStorage(STORAGE.PARTICIPANT_INVITE_MADE_ACCOUNT)
        if (code && hasAccount === false) handleSignUp()
    }, [])

    const handleLogin = () => {
        const credentials = submitForm(loginForm)
        if (!credentials) return
        setLoading(true)
        setError("")
        api.post('auth/login', {...credentials, rememberMe})
            .then(res => {
                let user = res.data
                setStorage(STORAGE.USER_ID, user.id)
                setStorage(STORAGE.USER_EMAIL, user.email)
                setStorage(STORAGE.COMPANY_ID, user.companyId)
                setStorage(STORAGE.USER_ROLE, user.type)
                setStorage(STORAGE.IS_ADMIN, user.type == 'Admin')
                setStorage(STORAGE.USER_NAME, `${user.firstName} ${user.lastName}`)
                if (user.type !== 'Participant') {
                    window.location.href = routeAfterLogin(user)
                    return
                }
                api.get('accounts/me/enrollments', { params: { page: 1, limit: 10 } })
                    .then(res => {
                        const enrollment = res.data.data[0]
                        window.location.href = enrollment ? routeEnrollment(enrollment) : '/participant/invites'
                    })
                    .catch(() => {
                        window.location.href = '/participant/invites'
                    })
            })
            .catch(err => {
                setIsVerified(err.response?.data?.message?.code != 'ACCOUNT_NOT_VERIFIED')
                setError(Array.isArray(err.response?.data?.message?.message) ? err.response.data.message.message[0] : err.response?.data?.message?.message)
                loginForm.password._setValue('')
                setLoading(false)
            })
    }

    const handleResend = () => {
        const email = loginForm.email._value
        if (!email) return
        api.post('accounts/resend-verification-email', { email })
            .then(_ => {
                setIsVerificationResent(true)
            })
            .catch(err => {
                setError(typeof(err.response.data.message.message) === Array ? err.response.data.message.message[0] : err.response.data.message.message)
            })
    }

    const handleSignUp = () => navigate('signup')

    const handleReset = () => {
        setIsForgetPassword(false)
        clearForm(loginForm)
        setError("")
    }

    return(
        <div className="flex columns gap-xs showing" style={{width: 'clamp(200px, 85%, 320px)'}}>
            {!isForgetPassword && <>
                <p className="section-title">Login</p>
                <div className="flex columns gap-xs" onKeyDown={(e) => { if (e.key === 'Enter') handleLogin(); }}>
                    <Input state={loginForm.email}/>
                    <Input state={loginForm.password}/>
                </div>
                <div className="flex center gap-xs interactable" onClick={() => setRememberMe(!rememberMe)}>
                    <input type="checkbox" className="scale-s" checked={rememberMe} style={{width: '50px'}}/>
                    <p className="card-body regular">Remember me</p>
                </div>
                {error && <>
                    <hr className="vi-spacer-xs o-50"/>
                    <p className="card-label text-center medium showing error capitalize">{error}</p>
                </>}
                {!isVerified && <div className="error-card columns gap-s standard-padding-s">
                    <p className="card-body text-center">Verify your account by following the instruction sent to your email address.</p>
                    {isVerificationResent && <p className="card-body uppercase medium">Email Resent</p>}
                    {!isVerificationResent && <button className="solid-accent" onClick={handleResend}>Resend Verification Email</button>}
                </div>}
                <LoadingButton className={`${isVerified ? 'solid-accent' : 'elevated'} large`} label={'Login'} onClick={handleLogin} loading={loading}/>
                <button className="outline large" onClick={() => setIsForgetPassword(true)}>Forgot Password?</button>
                <div className="flex gap-xs center justify-center">
                    <p className="card-label">Don't have an account?</p>
                    <button className="text" onClick={handleSignUp}>Sign Up</button>
                </div>
            </>}
            {isForgetPassword && <ForgotPassword onBack={handleReset} email={loginForm.email._value}/>}
        </div>
    )
}

function ForgotPassword({email, onBack}) {

    const [loading, setLoading] = useState(false)
    const [emailSent, setEmailSent] = useState(false)

    const forgotForm = {
        email: useInput("Email", "email", "email", [required], email)
    }

    const sendResetEmail = () => {
        const credentials = submitForm(forgotForm)
        if (!credentials) return
        setLoading(true)
        console.log(credentials);
        
        api.post('accounts/password/recovery', credentials)
            .then(_ => {
                setLoading(false)
                setEmailSent(true)
            })
            .catch(_ => {
                setLoading(false)
                onBack()
            })
    }
    
    return(
        <>
            <p className="section-title">Forgot Password</p>
            {!emailSent && <>
                <Input state={forgotForm.email}/>
                <LoadingButton className="solid-accent large" label={'Send Reset Password Email'} onClick={sendResetEmail} loading={loading}/>
            </>}
            {emailSent && <div className="dashed-card standard-padding-s">
                <p className="card-body">Email with reset password instructions has been sent to your inbox.</p>
            </div>}
            <button className={`large ${emailSent ? 'solid-accent' : 'outline'}`} onClick={onBack}>Back to Login</button>
        </>
    )
}